import { buildPathWithParams } from "@/hooks";
import { useCallback } from "react";
import { useHistory, useLocation } from "react-router-dom";

export const COMING_FROM_GALLERY = "GALLERY";
export const COMING_FROM_CATALOG = "CATALOG";

export function useHandlePressBack() {
  const history = useHistory();
  const pathLocation = useLocation<{ comingFrom?: string }>();
  const comingFrom = pathLocation.state?.comingFrom;

  const handlePressBackFromDetailsPage = useCallback(
    (path: string) => {
      if (
        comingFrom === COMING_FROM_GALLERY ||
        comingFrom === COMING_FROM_CATALOG
      ) {
        history.goBack();
      } else {
        const pathWithParams = buildPathWithParams(`/offerings/${path}`, {
          reset: true,
          keepOnReset: ["fromCatalog", "promoCode", "email"],
        });
        history.replace(pathWithParams);
      }
    },
    [history, comingFrom]
  );

  return { handlePressBackFromDetailsPage };
}
